import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

interface BigButtonProps {
  onClick: () => void;
  color: string;
  icon: IconProp;
  label: string;
}

export const BigButton = ({
  onClick,
  color,
  icon,
  label,
}: BigButtonProps) => (
  <div
    onClick={onClick}
    className={`
      cursor-pointer ${color} rounded-2xl h-24 flex flex-col justify-center items-center 
      text-white text-lg font-semibold text-center shadow-md hover:shadow-lg active:shadow-lg 
      transition-all duration-150 hover:scale-105 active:scale-95
    `}
  >
    <FontAwesomeIcon
      icon={icon}
      className="text-2xl mb-2"
    />
    {label}
  </div>
)